<template>
  <div id="download-basket-tool">
    <DxForm v-model:form-data="downloadData"
            :disabled="disabled"
            label-mode="floating"
            :show-colon-after-label="false"
    >
      <DxSimpleItem data-field="downloadFilename" editor-type="dxTextBox" :editor-options="{ maxLength: 100 }">
        <DxLabel text="File Name (Optional)"/>
      </DxSimpleItem>

      <DxSimpleItem data-field="downloadType"
                    editor-type="dxRadioGroup"
                    :editor-options="{
                        items: downloadTypes,
                        valueExpr: 'value',
                        displayExpr: 'displayedName'
                    }">
        <DxLabel text="Download Type"/>
      </DxSimpleItem>

      <DxItem item-type="button"
              :button-options="{
                  text: 'Download Basket',
                  type: 'action',
                  onClick: startDownload
              }"
      />
    </DxForm>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import { DxForm, DxSimpleItem, DxItem, DxLabel } from 'devextreme-vue/form'
  import axios from 'axios'
  import { storeToRefs } from 'pinia'
  import { useCabinetStore } from '@/stores/cabinetStore.js'
  import { useSearchPageStore } from '@/stores/searchPageStore.js'
  import { useToastStore } from '@/stores/toastStore.js'

  const cabinetStore = useCabinetStore()
  const { cabinetId } = storeToRefs(cabinetStore)

  const searchPageStore = useSearchPageStore()
  const { basketCount } = storeToRefs(searchPageStore)

  const toastStore = useToastStore()

  const downloadData = ref({ downloadType: 'file' }) // sets the default value in radio group to "Documents"
  const downloadTypes = [
    { value: 'file', displayedName: 'Documents'},
    { value: 'metadata', displayedName: 'Metadata'},
    { value: 'both', displayedName: 'Both'}
  ]

  const disabled = computed(() => !basketCount || basketCount.value <= 0)


  const startDownload = async () => {
    // Map downloadType to include_files and include_metadata
    const downloadType = downloadData.value.downloadType
    const includeFiles = downloadType === 'file' || downloadType === 'both'
    const includeMetadata = downloadType === 'metadata' || downloadType === 'both'

    // Generate filename if not provided
    const fileName = downloadData.value.downloadFilename?.trim() || generateFilename()

    const params = {
      cabinet_id: cabinetId.value,
      file_name: fileName,
      include_files: includeFiles,
      include_metadata: includeMetadata
    }

    try {
      const response = await axios.post('/api/download_basket', params)

      toastStore.showToastMessage(response.data.message || 'Download started successfully', 'success', 'add')
      // Reset form after successful download
      downloadData.value = { downloadType: 'file', downloadFilename: '' }
    }
    catch (error) {
      toastStore.showToastMessage('Failed to start download', 'error', 'close')
    }
  }

  const generateFilename = () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    const seconds = String(now.getSeconds()).padStart(2, '0')

    const dateStr = `${year}${month}${day}`
    const timeStr = `${hours}${minutes}${seconds}`

    return `factz_documents_${dateStr}_${timeStr}.zip`
  }
</script>

<style scoped lang="scss">
  #download-basket-tool {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
</style>
